import React from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import frLocale from "@fullcalendar/core/locales/fr";
import { useTranslation } from "react-i18next";

const calendarStyles = `
.fc {
  background: transparent;
  border-radius: 0;
  padding: 0;
  margin: 0;
}
.fc-toolbar-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: oklch(var(--bc));
  letter-spacing: -0.5px;
}
.fc-toolbar {
  margin-bottom: 1rem !important;
}
.fc-button {
  background: oklch(var(--b2)) !important;
  border: 1px solid oklch(var(--b3)) !important;
  color: oklch(var(--bc) / 0.7) !important;
  font-weight: 600 !important;
  font-size: 0.8rem !important;
  border-radius: 0.5rem !important;
  margin-right: 0.25rem !important;
  padding: 0.35em 0.85em !important;
  box-shadow: none !important;
  transition: background .15s, color .15s, border-color .15s !important;
}
.fc-button:hover, .fc-button-active, .fc-button:not(:disabled):active {
  background: oklch(var(--p)) !important;
  border-color: oklch(var(--p)) !important;
  color: oklch(var(--pc)) !important;
  box-shadow: none !important;
}
.fc-button:focus {
  box-shadow: none !important;
  outline: none !important;
}
.fc-day-today {
  background: oklch(var(--p) / 0.08) !important;
}
.fc-event {
  background: oklch(var(--p)) !important;
  border: none !important;
  border-radius: 0.375rem !important;
  font-weight: 500 !important;
  font-size: 0.8rem !important;
  padding: 1px 6px !important;
  box-shadow: none !important;
}
.fc-event:hover {
  background: oklch(var(--p) / 0.85) !important;
  cursor: pointer;
}
.fc-daygrid-day-number {
  font-weight: 600;
  color: oklch(var(--bc) / 0.8);
  font-size: 0.85rem;
}
.fc-col-header-cell-cushion {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: oklch(var(--bc) / 0.5);
}
.fc-scrollgrid {
  border-color: oklch(var(--b2)) !important;
}
.fc-scrollgrid td, .fc-scrollgrid th {
  border-color: oklch(var(--b2)) !important;
}
.fc-col-header {
  background: oklch(var(--b2)) !important;
}
.fc-daygrid-body, .fc-scrollgrid-sync-table {
  background: transparent !important;
}
.fc-day {
  background: oklch(var(--b1)) !important;
}
.fc-day-other {
  background: oklch(var(--b2) / 0.5) !important;
}
.fc-daygrid-day:hover {
  background: oklch(var(--b2) / 0.7) !important;
  cursor: pointer;
}
`;

const CalendarTab = ({ events, onDateClick, onEventClick }) => {
  const { i18n } = useTranslation();

  React.useEffect(() => {
    let styleTag = document.getElementById("calendar-styles");
    if (!styleTag) {
      styleTag = document.createElement("style");
      styleTag.id = "calendar-styles";
      document.head.appendChild(styleTag);
    }
    styleTag.innerHTML = calendarStyles;
  }, []);

  return (
    <FullCalendar
      plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
      initialView="dayGridMonth"
      locales={[frLocale]}
      locale={i18n.language === "fr" ? "fr" : "en"}
      headerToolbar={{
        left: "prev,next today",
        center: "title",
        right: "dayGridMonth,timeGridWeek,timeGridDay",
      }}
      buttonText={{
        today: i18n.language === "fr" ? "Aujourd'hui" : "Today",
        month: i18n.language === "fr" ? "Mois" : "Month",
        week: i18n.language === "fr" ? "Semaine" : "Week",
        day: i18n.language === "fr" ? "Jour" : "Day",
      }}
      nowIndicator={true}
      events={events}
      dateClick={(info) => onDateClick(info.dateStr)}
      eventClick={onEventClick}
      height="auto"
      firstDay={1}
    />
  );
};

export default CalendarTab;
